<template>
  <el-container>
    <main class="page__container page__container--fix container">
      <div class="container">
        <h2 class="page__title">Добавить камеру</h2>
        <el-form ref="form" :model="form" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Платформа" prop="id_media_core">
                <el-switch
                  v-model="form.id_media_core"
                  :active-value="MEDIA_CORE.VK3"
                  :inactive-value="MEDIA_CORE.VK2"
                  :active-text="MEDIA_CORE_NAME[MEDIA_CORE.VK3]"
                  :inactive-text="MEDIA_CORE_NAME[MEDIA_CORE.VK2]"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="$can('create', 'cameras_rtsp')">
              <el-form-item label="Тип камеры" prop="is_push_camera">
                <el-switch
                  v-model="form.is_push_camera"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="RTMP"
                  inactive-text="RTSP"
                  @change="changeCameraType"
                />
              </el-form-item>
            </el-col>
            <el-col :span="9" v-if="camerasParameters.has_cameras_serial">
              <el-form-item label="Завести камеру в биллинг" prop="push_to_billing">
                <el-switch
                  v-model="form.push_to_billing"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="!form.is_push_camera">
            <el-col :span="20">
              <el-form-item label="Заведение камеры" prop="createByRtspLink">
                <el-switch
                  v-model="createByRtspLink"
                  active-text="по ссылке"
                  inactive-text="классическое"
                  @change="onChangeCreatingCameraType"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Название" prop="short_name">
                <el-input v-model="form.short_name" size="small" placeholder="Камера #1" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Адрес" prop="address">
                <el-input v-model="form.address" size="small" placeholder="Кемерово, Бакинский пер. 15" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" >
              <el-form-item label="Владелец" prop="id_account_master">
                <select-client
                  :owner-id="form.id_account_master"
                  @change="(client) => (form.id_account_master = client.id_account)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Срок хранения" prop="archive_depth">
                <select-tariff
                  :tariff-id="form.archive_depth"
                  @change="(tariff) => (form.archive_depth = tariff.archive_depth)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="!createByRtspLink">
              <el-form-item label="IP адрес" prop="ip">
                <el-input v-model="form.ip" size="small" placeholder="1.1.1.1" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Часовой пояс" prop="timezone">
                <br />
                <el-input-number id="timezone" v-model="form.timezone" :min="-12" :max="12" size="small"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="createByRtspLink">
            <el-col :span="12">
              <el-form-item label="RTSP ссылка" prop="rtsp_stream">
                <el-input v-model="form.rtsp_stream" size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" v-if="!createByRtspLink">
              <el-form-item label="Логин" prop="login">
                <el-input size="small" v-model="form.login" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="!createByRtspLink">
              <el-form-item label="Пароль" prop="password">
                <el-input style="margin-top: 4px" size="small" show-password v-model="form.password">
                  <el-button slot="append" size="small" @click="generatePassword"> Случайный </el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="camerasParameters.has_cameras_serial && !createByRtspLink">
              <el-form-item label="Серийный номер" prop="serial_number">
                <el-input size="small" v-model="form.serial_number" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Инстанс" prop="id_md_instance">
                <el-select
                  v-model="form.id_md_instance"
                  size="small"
                  placeholder="Не указано"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="val in motionDetectionInstances"
                    :key="val.id_md_instance"
                    :label="val.instance_name"
                    :value="val.id_md_instance"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Имя камеры в детекции" prop="md_filter_value">
                <el-input v-model="form.md_filter_value" size="small" placeholder="(значение по-умолчанию)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="!isClassicRtspCreation">
            <el-col :span="24">
              <el-form-item label="Серая RTSP ссылка" prop="grey_rtsp_link">
                <el-input v-model="form.grey_rtsp_link" size="small" placeholder="Серая RTSP ссылка" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-else>
            <el-col :span="12">
              <el-form-item label="Серый IP адрес" prop="grey_ip">
                <el-input v-model="form.grey_ip" size="small" placeholder="1.1.1.1" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="RTSP порт камеры" prop="rtsp_port">
                <el-input v-model.number="form.rtsp_port" size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12" v-if="!createByRtspLink">
              <el-form-item label="Юридическое лицо" prop="id_org">
                <select-org
                  :org-id="form.id_org"
                  @change="(org) => (form.id_org = org.id_org)"
                  @clear="() => (form.id_org = null)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="canSeeInstallationLocation" label="Место установки" prop="id_location">
                <el-select
                  v-model="form.id_location"
                  size="small"
                  placeholder="Не указано"
                  style="width: 100%"
                  clearable
                >
                  <el-option
                    v-for="val in installationLocations"
                    :key="val.id_location"
                    :label="val.name_location"
                    :value="val.id_location"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="form.is_push_camera">
            <!-- для RTMP-камер вернул выбор модели (но без выбора порта и дополнительных полей) -->
            <el-col :span="12">
              <el-form-item label="Модель" prop="id_model">
                <select-model
                  :model-id="form.id_model"
                  :disabled="form.serial_number !== ''"
                  :placeholder="form.serial_number !== '' ? 'Определим по серийному номеру' : 'Выберите модель камеры'"
                  @change="(model) => (form.id_model = model.id_model)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="!form.is_push_camera">
            <el-col :span="6" v-if="!createByRtspLink">
              <el-form-item label="Модель" prop="id_model">
                <select-model
                  :model-id="form.id_model"
                  @change="(model) => (form.id_model = model.id_model)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="!createByRtspLink">
              <el-form-item label="Порт" prop="port">
                <el-input size="small" v-model.number="form.port" />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              style="display: inline-flex"
            >
              <el-form-item label="Автоопределение аудио-кодека" prop="detect_audio_codec" v-if="createByRtspLink">
                <el-switch
                  v-model="form.detect_audio_codec"
                  :active-value="1"
                  :inactive-value="0"
                  :disabled="isAutoAudioCodecLocked"
                  @change="changeCameraDetectAudioCodec"
                />
              </el-form-item>
              <el-form-item label="Необходимость транскодинга звука" prop="need_sound" v-if="!form.detect_audio_codec">
                <el-switch
                  v-model="form.need_sound"
                  :disabled="form.mute_sound"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
              <el-form-item label="Mute" prop="mute_sound" v-if="!createByRtspLink">
                <el-switch
                  v-model="form.mute_sound"
                  :disabled="!form.need_sound"
                  :active-value="1"
                  :inactive-value="0"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="id_sidetask_setting" label="Тип side-task`а" v-if="createByRtspLink && !form.detect_audio_codec && form.need_sound">
                <select-camera-side-task-type
                  :selected="form.id_sidetask_setting"
                  @change="onSidetaskChange"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="model.is_onvif === 1 && !form.is_push_camera">
            <el-col :span="6">
              <el-form-item label="Порт ONVIF" prop="port_onvif">
                <el-input size="small" v-model.number="form.port_onvif" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Логин ONVIF" prop="login_onvif">
                <el-input size="small" v-model="form.login_onvif" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Пароль ONVIF" prop="password_onvif">
                <el-input size="small" show-password v-model="form.password_onvif" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="$can('read', 'intercoms') && operatorCan()">
            <el-col :span="6">
              <el-form-item label="Домофон" prop="id_intercom">
                <select-intercom
                  :intercom-id="form.id_intercom"
                  @change="(intercom) => (form.id_intercom = intercom.id_intercom)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Комментарий" prop="description">
                <el-input type="textarea" v-model="form.description" :rows="2" maxlength="300" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button :loading="loading" class="page__active_button" type="success" icon="el-icon-edit" @click="onSaveAndEdit">
        Добавить и редактировать
      </el-button>
      <el-button :loading="loading" class="page__active_button" type="primary" icon="el-icon-check" @click="onSave">
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import {
  length,
  required,
  validatorOptionalIp,
  validatorNoDollar ,
  validatorIntegerRange,
  validatorNumberMin,
  validatorNumberRange,
} from "@/core/helpers/validators";
import { mapState, mapActions } from "vuex";
import SelectClient from "@/core/components/features/SelectClient";
import SelectModel from "@/core/components/features/SelectModel";
import { ApiService } from "@/api";
import SelectTariff from "@/components/Tariffs/components/feature/SelectTariff";
import SelectIntercom from '@/core/components/features/SelectIntercom';
import SelectOrg from "@/components/Orgs/components/feature/SelectOrg";
import SelectCameraSideTaskType from "@/core/components/SelectCameraSidetask";
import { MEDIA_CORE, MEDIA_CORE_NAME } from "@/core/helpers/const";
import { DEFAULT_RTSP_PORT, normalizeRtspPort, prepareGreyRtspPayload } from "./greyRtsp";

export default {
  name: "CameraCreate",
  components: {
    SelectTariff,
    SelectClient,
    SelectModel,
    SelectIntercom,
    SelectOrg,
    SelectCameraSideTaskType,
  },
  data() {
    return {
      transcode_audio: 0,
      loading: false,
      createByRtspLink: false,
      installationLocations: [],
      motionDetectionInstances: [],
      MEDIA_CORE,
      MEDIA_CORE_NAME,
      form: {
        id_media_core: MEDIA_CORE.VK3,
        short_name: "",
        address: "",
        timezone: "",
        id_account_master: null,
        id_md_instance: null,
        login: "",
        password: "",
        serial_number: "",
        ip: "",
        archive_depth: null,
        description: "",
        push_to_billing: null,
        is_push_camera: 1,
        id_model: null,
        need_sound: false,
        mute_sound: false,
        port: 554,
        id_intercom: null,
        id_org: null,
        port_onvif: null,
        login_onvif: null,
        password_onvif: null,
        rtsp_stream: "",
        id_sidetask_setting: 1,
        detect_audio_codec: 0,
        id_location: null,
        md_filter_value: "",
        grey_rtsp_link: "",
        grey_ip: "",
        rtsp_port: DEFAULT_RTSP_PORT,
      },
      rules: {
        short_name: [required(), length(3, 64)],
        address: [length(4, 200)],
        ip: [],
        id_account_master: [required("number")],
        description: [length(0, 300)],
        archive_depth: [required("number")],
        login: [validatorNoDollar],
        password: [validatorNoDollar],
        serial_number: [],
        timezone: [],
        push_to_billing: [],
        is_push_camera: [],
        id_model: [],
        need_sound: [],
        mute_sound: [],
        port: [required("number")],
        id_intercom: [],
        id_org: [],
        port_onvif: [],
        login_onvif: [],
        password_onvif: [],
        rtsp_stream: [length(7, 2048)],
        id_sidetask_setting: [validatorNumberMin(1)],
        detect_audio_codec: [],
        grey_rtsp_link: [length(0, 200)],
        grey_ip: [validatorOptionalIp],
        rtsp_port: [validatorIntegerRange(1, 65535)],
      },
    };
  },
  computed: {
    isClassicRtspCreation() {
      return !this.form.is_push_camera && !this.createByRtspLink;
    },
    canSeeInstallationLocation() {
      let idOperator = localStorage.getItem("operator")
      return ["241", "2", "341"].includes(idOperator)
      /* костыль, чтобы показывать выбор места установки только в linkvideo (241), TestOperator2 (2), reserv (341),
      нужно переделать, когда будет горизонтальное разграничение прав операторов */
    },
    ...mapState("cameras", {
      camerasParameters: (state) => state.cameras.parameters,
      model: (state) => state.model
    }),
    isVk3() {
      return this.form.id_media_core === MEDIA_CORE.VK3;
    },
    // ТЗ 3.1: при заведении RTSP-камеры по ссылке на ВК 3.0 свитч автоопределения аудио-кодека
    // становится не активным — сервера новой платформы сами определяют необходимость транскода.
    isAutoAudioCodecLocked() {
      return this.isVk3 && this.createByRtspLink && !this.form.is_push_camera;
    },
  },
  watch: {
    "form.serial_number"() {
      if (this.form.serial_number !== "") {
        this.form.id_model = ""
      }
    },
    "form.id_model"(idModel) {
      this.getModel(idModel)
        .then(() => {
          // Ответ мог прийти после того, как модель сменили или сбросили — тогда применять
          // его нельзя, иначе он затрёт уже выполненный resetTranscodingValues().
          if (this.form.id_model !== idModel) return;

          this.transcode_audio = this.model.transcode_audio
          this.form.need_sound = this.model.transcode_audio
        })
    },
    // Как только условие ТЗ 3.1 выполнено, фиксируем автоопределение включённым: транскод
    // на ВК 3.0 определяет сервер, а поля транскодинга при этом скрыты и не должны нести
    // в запрос значения, выставленные до переключения платформы.
    isAutoAudioCodecLocked(locked) {
      if (!locked) return;
      this.form.detect_audio_codec = 1;
      this.resetTranscodingValues();
    }
  },
  mounted() {
    let loading = this.$loading({
      lock: true,
      text: "Загрузка",
    });
    this.getParameters()
      .then(() => {
        loading.close();
        this.form.timezone = this.camerasParameters.operator_timezone || 0;
      })
      .catch(() => {
        this.$message.error(e.response.data.error || "Неизвестная ошибка");
        this.$router.push("/");
      });
  },
  created() {
    this.getInstallationLocations()
      .then((res) => {
          this.installationLocations = res
        }
      );
    this.getMotionDetectionInstances()
      .then((res) => {
          this.motionDetectionInstances = res
        }
      );
  },
  methods: {
    ...mapActions("cameras", {
      getParameters: "GET_OPERATOR_CAMERAS_PARAMETERS",
      getModel: "GET_MODEL",
      getInstallationLocations: "GET_CAMERA_INSTALLATION_LOCATIONS",
      getMotionDetectionInstances: "GET_MOTION_DETECTION_INSTANCES",
    }),
    onSidetaskChange(setting) {
      this.form.id_sidetask_setting = setting.id_sidetask_setting;
    },
    generatePassword() {
      const length = 8;
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let password = "";

      for (var i = 0, n = charset.length; i < length; ++i) {
        password += charset.charAt(Math.floor(Math.random() * n));
      }

      this.form.password = password;
    },
    onChangeCreatingCameraType(createByRtspLink) {
      if (!createByRtspLink) {
        this.form.rtsp_stream = null;
        this.form.detect_audio_codec = 0;
      } else {
        this.form.detect_audio_codec = 1;
      }
    },
    changeCameraType() {
      this.resetTranscodingValues();
      this.form.id_model = null;
      // Режим «по ссылке» есть только у RTSP-камер: его переключатель скрыт при is_push_camera,
      // но значение оставалось прежним и утаскивало rtsp_stream с detect_audio_codec
      // в тело запроса push-камеры.
      this.createByRtspLink = false;
      this.onChangeCreatingCameraType(false);
    },
    changeCameraDetectAudioCodec() {
      this.resetTranscodingValues();
    },
    resetTranscodingValues() {
      this.form.need_sound = false;
      // Без сброса Mute форма запиралась: транскодинг заблокирован включённым Mute,
      // а Mute — выключенным транскодингом.
      this.form.mute_sound = false;
      this.form.id_sidetask_setting = 1;
    },
    normalizeGreyRtspPort() {
      if (this.isClassicRtspCreation) {
        this.form.rtsp_port = normalizeRtspPort(this.form.rtsp_port);
      }
    },
    createCamera() {
      const newCamera = prepareGreyRtspPayload(this.form, this.isClassicRtspCreation);

      if (!this.form.rtsp_stream || (this.form.rtsp_stream && !this.form.need_sound) || (this.form.rtsp_stream && this.form.detect_audio_codec)) {
        delete newCamera.id_sidetask_setting
      }

      return ApiService.cameras.create(newCamera)
    },
    onSave() {
      this.normalizeGreyRtspPort();
      let formIsValid;
      this.$refs["form"].validate((status) => {
        formIsValid = status;
      });

      if (!formIsValid) return false;

      this.loading = true;

      this.createCamera()
        .then(({ id_camera }) => {
          this.$message({
            type: "success",
            message: "Камера успешно создана",
          });

          this.$router.push({ name: "cameras:edit", params: { id: id_camera } });
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.response.data.error || "Неизвестная ошибка",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSaveAndEdit() {
      this.normalizeGreyRtspPort();
      let formIsValid;
      this.$refs["form"].validate((status) => {
        formIsValid = status;
      });

      if (!formIsValid) return false;

      this.loading = true;

      this.createCamera()
        .then(({ id_camera }) => {
          this.$message({
            type: "success",
            message: "Камера успешно создана",
          });

          const routeData = this.$router.resolve({ name: "cameras:edit", params: { id: id_camera } });
          window.open(routeData.href, '_blank');
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.response.data.error || "Неизвестная ошибка",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    operatorCan() {
      return localStorage.getItem('operator') == 621 || localStorage.getItem('operator') == 1021
    },
  },
};
</script>
